module.exports = __webpack_public_path__ + "img/digitalized-1.339e8398.png";